import { render } from "./SVGRuler.vue?vue&type=template&id=4800c99b"
import script from "./SVGRuler.vue?vue&type=script&lang=js"
export * from "./SVGRuler.vue?vue&type=script&lang=js"

import exportComponent from "/home/tachyon/wardrobe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__